import { Node } from "../../node-editor/dto";

// 运算符
const isArithmetic = (content: string) =>
  ["+", "-", "*", "/"].includes(content);
// 左括号
const isLeftBracket = (content: string) => content === "(";
// 右括号
const isRightBracket = (content: string) => content === ")";
// 是否为符号
const isOperator = (content: string) =>
  isArithmetic(content) || isLeftBracket(content) || isRightBracket(content);
/**
 * 校验合法计算公式
 * @param formulaArray 公式内容
 * @param fields 动态字段
 * @returns 错误节点id数组
 */
function validateMathFormula(formulaArray: Node[], fields: string[]) {
  const invalidIds = [];
  const contents = formulaArray.map((item) => item.content);
  // 开头为运算符
  if (isArithmetic(contents[0])) {
    invalidIds.push(formulaArray[0].id);
  }
  // 结尾为运算符
  if (isArithmetic(contents[contents.length - 1])) {
    invalidIds.push(formulaArray[contents.length - 1].id);
  }
  // 括号
  const stack = [];
  // 括号内是否有数字或者字段
  let hasNumberOrFieldInBrackets = false;
  for (let i = 0; i < contents.length; i++) {
    const current = contents[i];
    const { id, content } = formulaArray[i];
    // 当前是否为正确的数字
    const isInvalidNumber =
      !fields.includes(content) &&
      !isOperator(current) &&
      isNaN(Number(current));
    if (isInvalidNumber) {
      invalidIds.push(id);
    }
    // ========= 以下 括号匹配&括号之间是否有数字的逻辑 =========
    if (isLeftBracket(current)) {
      stack.push({ id, index: i });
      hasNumberOrFieldInBrackets = false;
    } else if (isRightBracket(current)) {
      if (stack.length === 0) {
        invalidIds.push(id); // 多余右括号
      } else {
        const lastBracket = stack.pop();
        if (!hasNumberOrFieldInBrackets) {
          invalidIds.push(lastBracket.id); // 括号内无数字
          invalidIds.push(id);
        }
      }
    } else if (!isArithmetic(current) && stack.length > 0) {
      hasNumberOrFieldInBrackets = true; // 括号内有数字或者字段
    }
    // ========= 以上 括号匹配&括号之间是否有数字的逻辑 =========

    // ========= 以下 相邻字符是否合法的逻辑 =========
    if (i === contents.length - 1) {
      continue;
    }
    const next = contents[i + 1];
    const { id: nextId, content: nextContent } = formulaArray[i + 1];
    // 当前是否为数字或字段
    const isCurrentNumberOrField =
      !isOperator(current) || fields.includes(content);
    // 当前是否为数字或字段
    const isNextNumberOrField =
      !isOperator(next) || fields.includes(nextContent);
    // 当前是否为运算符
    const isCurrentOperator = isArithmetic(current);
    // 下一个是否为运算符
    const isNextOperator = isArithmetic(next);
    // 数字/字段( 的情况
    const isNumberOrFieldLeftAdjacentLeftBracket =
      isLeftBracket(next) && isCurrentNumberOrField;
    // )数字/字段 的情况
    const isRightBracketRightAdjacentNumberOrField =
      isRightBracket(current) && isNextNumberOrField;
    // (操作符 的情况
    const isLeftBracketLeftAdjacentOperator =
      isLeftBracket(current) && isNextOperator;
    // 操作符) 的情况
    const isOperatorLeftAdjacentRightBracket =
      isCurrentOperator && isRightBracket(next);
    if (
      isNumberOrFieldLeftAdjacentLeftBracket ||
      isRightBracketRightAdjacentNumberOrField ||
      (isCurrentNumberOrField && isNextNumberOrField) ||
      (isCurrentOperator && isNextOperator) ||
      isLeftBracketLeftAdjacentOperator ||
      isOperatorLeftAdjacentRightBracket
    ) {
      invalidIds.push(id, nextId);
    }
    // ========= 以上 相邻字符是否合法的逻辑 =========
  }
  // 未闭合的左括号
  invalidIds.push(...stack.map((item) => item.id));
  // 去重
  return Array.from(new Set(invalidIds));
}

const formulaInputs = [
  {
    label: "删除",
    color: "#FF2A2A",
    type: "delete",
  },
  {
    label: "(",
    type: "bracket",
  },
  {
    label: ")",
    type: "bracket",
  },
  {
    label: "/",
    type: "operator",
  },
  {
    label: "7",
    type: "number",
  },
  {
    label: "8",
    type: "number",
  },
  {
    label: "9",
    type: "number",
  },
  {
    label: "*",
    type: "operator",
  },
  {
    label: "4",
    type: "number",
  },
  {
    label: "5",
    type: "number",
  },
  {
    label: "6",
    type: "number",
  },
  {
    label: "-",
    type: "operator",
  },
  {
    label: "1",
    type: "number",
  },
  {
    label: "2",
    type: "number",
  },
  {
    label: "3",
    type: "number",
  },
  {
    label: "+",
    type: "operator",
  },
  {
    label: "0",
    type: "number",
    span: 3,
  },
  {
    label: ".",
    type: "number",
  },
];

export {
  validateMathFormula,
  isArithmetic,
  isLeftBracket,
  isRightBracket,
  isOperator,
  formulaInputs,
};
